import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: '¡Gracias por tu valoración!',
  text: '¿Hay algo que podamos mejorar? Comparte tu opinión con nosotros.',
  form: {
    fields: [
      {
        type: 'textarea',
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Tu opinión...'
      }
    ],
    submit: {
      label: 'Enviar'
    }
  }
};